import React from 'react';
import { connect } from 'react-redux';
import {
	Table,
	Button,
	Modal,
	Spin,
	message,
	Icon,
	TreeSelect,
	Form,
	Input,
	Select,
	InputNumber
} from 'antd';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';

import {
	fetchDepartmentPositionList,
	initPosition,
	multiDeletePosition,
	updatePosition,
	initMovePosition,
	movePosition,
	addPosition
} from '../../actions/department-structure-actions.js';
import { fetchDepartmentsList } from '../../actions/department-structure-actions.js';

import departmentPositionService from '../../services/DepartmentStructure/department-position-service.js';

import './style.less'

const { TreeNode } = TreeSelect;
class DepartmentPosition extends React.Component {
	state = { positionCurrentPage: 1 };
	rowSelection = {
		onChange: (selectedRowKeys, selectedRows) => {
			let ids = selectedRows.map(row => row.id);
			this.setState({ selectedIDs: ids });
		}
	};
	componentWillMount() {
		this.props.fetchDepartmentPositionList();
		this.props.fetchDepartmentsList();
		// this.props.initPosition();

		// this.props.initMovePosition();
	}
	componentWillReceiveProps(nextProps) {
		// console.log(nextProps);
	}
	editPosition(text, record, index) {
		this.props.initPosition(() => {
			this.props.departmentStructure.initPosition.Businesses.forEach((business, businessIndex) => {
				if (business.business_id === this.props.departmentStructure.positionList[index].business_id) {
					this.setState({ currentBusinessIndex: businessIndex });
					return;
				}
			});
			this.setState({ currentPosition: this.props.departmentStructure.positionList[index] });
		});
		this.setState({ currentIndex: index });
	}
	addPosition() {
		this.props.initPosition();
		let position = {
			name: null,
			department_id: null,
			department_name: '',
			business_id: null,
			business_name: '',
			business_level_value: null,
			staff_size: null,
			qualifications: null,
			responsibility_description: null
		};
		this.setState({ currentPosition: position });
	}
	closePositionModal() {
		this.setState({ currentPosition: null });
	}
	handleSubmit(e) {
		this.props.form.validateFields((err, values) => {
			if (!err) {
				if (this.state.currentPosition.id) {
					// console.log(values, this.state.currentPosition.id, this.state.currentIndex);
					values.id = this.state.currentPosition.id;
					this.props.updatePosition(values, this.state.currentIndex, status => {
						if (status) {
							this.setState({ currentPosition: null });
							message.success('修改职位成功', 4);
							this.props.fetchDepartmentPositionList(this.state.positionCurrentPage);
						}
					});
				} else {
					this.props.addPosition(values, status => {
						if (status) {
							this.setState({ currentPosition: null });
							message.success('添加职位成功', 4);
							this.props.fetchDepartmentPositionList(this.state.positionCurrentPage);
						}
					});
				}
			}
		});
	}
	handleMergeSubmit(event) {
		this.props.form.validateFields((err, values) => {
			if (!values.merged_department || '-1' === values.merged_department) {
				message.error('请选择要合并到的部门', 4);
				return false;
			}
			let posts = {
				CurrentId: this.state.currentMergeId,
				TargetId: values.merged_department
			}
			this.props.movePosition(posts, status => {
				if (status) {
					message.success('合并部门成功', 4);
					this.setState({ mergePositionModal: false });
					this.props.fetchDepartmentPositionList(this.state.positionCurrentPage);
				}
			});
		})
	}
	changeBusiness(business_id) {
		this.props.departmentStructure.initPosition.Businesses.forEach((business, index) => {
			if (business.business_id === business_id) {
				this.setState({ currentBusinessIndex: index });
				return;
			}
		});
	}
	multiDeletePosition() {
		let ids = this.state.selectedIDs;
		if (!ids || ids.length === 0) {
			message.error('请选择需要删除的职位', 4);
			return;
		}
		Modal.confirm({
			title: '确定删除?',
			okText: '确认',
			cancelText: '取消',
			onOk: () => {
				this.props.multiDeletePosition({ ids: ids }, (status, alertMessage) => {
					if (status) {
						message.success('删除职位成功', 4);
						this.props.fetchDepartmentPositionList(this.state.positionCurrentPage);
					} else {
						message.error(alertMessage, 4);
					}
				})
			},
			onCancel: () => { }
		});
	}
	mergePosition(text, record, index) {
		this.props.initMovePosition(record.id, () => {
			this.setState({ mergePositionModal: true });
			this.setState({ currentMergeId: record.id });
		});
	}
	closeMergePositionModal() {
		this.setState({ mergePositionModal: false });
	}

	/*  openExportPositionModal() {
			this.setState({exportPositionModal: true});
	  }
	  closeExportPositionModal() {
			this.setState({exportPositionModal: false});  	
	  }*/
	exportPosition() {
		// window.open("http://www.baidu.com");
		let ref = Modal.info({ content: "正在准备需要下载的文件, 下载文件可能被浏览器阻挡, 请注意！" });
		departmentPositionService.exportPosition(res => {
			// console.log(22222);
			// console.log(res);
			ref.destroy();
			if (res.data.Success) {
				window.open(res.data.Message);
			} else {
				message.error('下载失败', 4);
			}
		}, err => {
			message.error('下载失败', 4);
		});
		// this.setState({exportPositionModal: false});
	}


	downloadTemplate = () => {
		let ref = Modal.info({ content: "正在准备需要下载的模板" });
		departmentPositionService.downloadTemplate(res => {
			ref.destroy();
			if (res.data.Success) {
				window.open(res.data.Message);
			}
		});
	}
	setUploadedFile = event => {
		this.setState({ uploadedFile: event.target.files[0] });
	}
	importPosition = () => {
		if (this.state.uploadedFile) {
			let ref = Modal.info({ content: "正在导入文件, 请稍后..." });
			let formData = new FormData();
			formData.append("uploadedFile", this.state.uploadedFile);
			departmentPositionService.importPosition(formData, res => {
				ref.destroy();
				if (res.data.Success) {
					message.success('导入文件成功，' + res.data.Message, 4);
					this.setState({ importModal: false });
					this.props.fetchDepartmentPositionList();
					if (res.data.Object) {
						window.open(res.data.Object);
					}
				} else {
					message.error("导入文件失败, " + res.data.Errors[0], 4)
				}
			}, err => message.error("导入文件失败", 4));
		} else {
			message.error("请选择需要导入的文件", 4);
		}
	}
	openImportPositionModal() {
		this.setState({ importPositionModal: true });
	}
	closeImportPositionModal() {
		this.setState({ importPositionModal: false });
	}
	pageDepartmentPositionList(pagination) {
		this.setState({ positionCurrentPage: pagination.current });
		this.props.fetchDepartmentPositionList(pagination.current);
	}
	setNameFilter = name => {
		this.setState({ name: name });
		this.props.fetchDepartmentPositionList(
			{
				...this.state,
				name: name
			}
		);
	}
	onSelectTreeChange = (id, value, event) => {
		console.log( event.triggerValue);
		this.setState({
			department_id: event.triggerValue,
		});
		this.props.fetchDepartmentPositionList(
			{
				...this.state,
				department_id: event.triggerValue,
			}
		);
	}
	renderTreeNodes = (data) => {
		return data.map((item) => {
			if (item.children) {
				return (
					<TreeNode title={item.name} value={`${item.id}`} key={item.id} dataRef={item}>
						{item.children.length !== 0 && this.renderTreeNodes(item.children)}
					</TreeNode>
				);
			}
			return <TreeNode {...item} />;
		});
	}


	render() {
		const columns = [
			{
				title: '职位名称',
				dataIndex: 'name',
			}, {
				title: '所属部门',
				dataIndex: 'department_name',
			}, {
				title: '对应职务',
				dataIndex: 'business_name',
			}, {
				title: '对应职级',
				dataIndex: 'business_level_value',
			}, {
				title: '编制人数',
				dataIndex: 'staff_size',
			}, {
				title: '操作',
				dataIndex: 'actions',
				render: (text, record, index) =>
					<span>
						{this.props.access.departmentPosition.u_value && <span title="编辑" onClick={this.editPosition.bind(this, text, record, index)}>
							<Button icon="edit" size="small" className="row-action-btn">编辑</Button>
						</span>}
						{this.props.access.departmentPosition.merge_value && <span title="合并" onClick={this.mergePosition.bind(this, text, record, index)}>
							<Button icon="fork" size="small" className="row-action-btn">合并</Button>
						</span>}
					</span>
			}
		];
		const { departmentsList } = this.props.departmentStructure;
		return (
			<div className="app-module-item">
				<div className="colAction">
					{this.props.access.departmentPosition.c_value && <Button type="primary" onClick={this.addPosition.bind(this)} style={{ marginRight: "10px" }}>
						<Icon type="plus-circle-o" />
						<span>新增</span>
					</Button>}

					{this.props.access.departmentPosition.d_value && <Button type="primary" onClick={this.multiDeletePosition.bind(this)} style={{ marginRight: "10px" }}>
						<Icon type="delete" />
						<span>批量删除</span>
					</Button>}

					{this.props.access.departmentPosition.import_value && <Button type="primary" onClick={this.openImportPositionModal.bind(this)} style={{ marginRight: "10px" }}>
						<Icon type="cloud-upload-o" />
						<span>导入</span>
					</Button>}

					{this.props.access.departmentPosition.export_value && <Button type="primary" onClick={this.exportPosition.bind(this)} style={{ marginRight: "10px" }}>
						<Icon type="cloud-download-o" />
						<span>导出</span>
					</Button>}
					<div className="colAction" style={{ float: "right", margin: "0px 10px 10px 0px" }}>
						<Input.Search
							placeholder="名称"
							onSearch={this.setNameFilter}
							style={{ width: 200 }}
							enterButton />
					</div>
					<div className="colAction" style={{ float: "right", margin: "0px 10px 10px 0px" }}>
					{departmentsList &&
						<TreeSelect style={{ minWidth: "300px", marginBottom: '15px' }}
							// multiple
							placeholder="请选择部门"
							// showSearch={false}
							autoExpandParent={true}
							dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
							treeDefaultExpandAll
						onChange={this.onSelectTreeChange.bind(this)}
						>
							{/*<Select style={{width:"400px"}}>
												{this.props.departmentStructure.initPositionStatus &&
													this.props.departmentStructure.initPosition.Departments.map(department => {
														return (<Select.Option key={department.Value} value={department.Value}>{department.Text}</Select.Option>)
													})
												}
											</Select>*/}
							{this.renderTreeNodes(departmentsList)}
						</TreeSelect>}
					</div>
				</div>

				{this.props.departmentStructure.positionListStatus ?
					<Table rowSelection={this.rowSelection} columns={columns}
						dataSource={this.props.departmentStructure.positionList}
						rowKey={record => record.id}
						pagination={{
							total: this.props.departmentStructure.totalPosition,
							pageSize: this.props.departmentStructure.pageSizePosition,
							current: this.props.departmentStructure.pagePosition,
							defaultCurrent: 1
						}}
						onChange={this.pageDepartmentPositionList.bind(this)} />
					: <div style={{ textAlign: 'center', margin: '100px 0px' }}><Spin size="large" /></div>}
				<Modal width="800px"
					visible={this.state.importPositionModal}
					title="职位导入"
					destroyOnClose={true}
					onCancel={this.closeImportPositionModal.bind(this)}
					footer={<Button type="back" onClick={this.closeImportPositionModal.bind(this)}>关闭</Button>}>
					<div style={{ textAlign: "center", margin: "20px 0px 20px" }}>
						<div>
							<Button type="primary" onClick={this.downloadTemplate}>
								<Icon type="cloud-download-o" />
								<span>下载模板</span>
							</Button>
						</div>
						<div style={{ marginTop: "40px" }}>
							<div>导入文件</div>
							<Input type="file" style={{ height: "38px" }} onChange={this.setUploadedFile} />
							<Button type="primary" style={{ marginTop: "20px" }} onClick={this.importPosition}>
								<Icon type="cloud-upload-o" />
								<span>开始导入</span>
							</Button>
						</div>
					</div>
				</Modal>
				{/*				<Modal width="800px"
					visible={this.state.exportPositionModal}
					title="职位导出"
					destroyOnClose={true}
					onCancel={this.closeExportPositionModal.bind(this)}
					footer={<Button type="back" onClick={this.closeExportPositionModal.bind(this)}>关闭</Button>}>
					<div style={{textAlign:"center",margin:"20px 0px 20px"}}>
						<Button type="primary" onClick={this.exportPosition.bind(this)}>
							<Icon type="cloud-download-o" />
							<span>开始导出</span>
						</Button>
					</div>
				</Modal>*/}
				<Modal width="800px"
					visible={this.state.mergePositionModal}
					title="职位合并"
					destroyOnClose={true}
					onCancel={this.closeMergePositionModal.bind(this)}
					onOk={this.handleMergeSubmit.bind(this)} >
					<div style={{ textAlign: "center", margin: "20px 0px 60px" }}>
						<Form onSubmit={this.handleMergeSubmit.bind(this)} className="login-form" layout="inline">
							<div className="position-form-item">
								{departmentsList &&
									<Form.Item label="合并到:">
										{this.props.form.getFieldDecorator('merged_department', {
											rules: [],
											initialValue: '-1'
										})(


											<Select style={{ width: "400px" }}>
												<Select.Option disabled key="-1" value="-1">请选择职位</Select.Option>
												{this.props.departmentStructure.departmentListStatus &&
													this.props.departmentStructure.departmentList.map(department => {
														return (<Select.Option key={department.Value} value={department.Value}>{department.Text}</Select.Option>)
													})}
											</Select>

										)}
									</Form.Item>}
							</div>
						</Form>
					</div>
				</Modal>
				<Modal width="1000px"
					visible={!!this.state.currentPosition}
					title="职位"
					destroyOnClose={true}
					onCancel={this.closePositionModal.bind(this)}
					onOk={this.handleSubmit.bind(this)} >
					{this.state.currentPosition &&
						<div style={{ textAlign: "center" }}>
							<Form onSubmit={this.handleSubmit.bind(this)} className="login-form" layout="inline">
								<div className="position-form-item">
									<Form.Item label="职位名称">
										{this.props.form.getFieldDecorator('name', {
											rules: [{ required: true, message: '请选择职位名称' }],
											initialValue: this.state.currentPosition.name
										})(<Input placeholder="职位名称" style={{ width: "400px" }} />)}
									</Form.Item>
								</div>
								<div className="position-form-item">
									{departmentsList &&
										<Form.Item label="所属部门">
											{this.props.form.getFieldDecorator('department_id', {
												rules: [{ required: true, message: '请输入所属部门' }],
												initialValue: this.state.currentPosition.department_id ? this.state.currentPosition.department_id : null
											})(

												<TreeSelect style={{ minWidth: "400px", marginBottom: '15px' }}
													// multiple
													placeholder="请选择部门"
													// showSearch={false}
													autoExpandParent={true}
													dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
													treeDefaultExpandAll
												// onChange={this.onSelectTreeChange.bind(this)}
												>
													{/*<Select style={{width:"400px"}}>
												{this.props.departmentStructure.initPositionStatus &&
													this.props.departmentStructure.initPosition.Departments.map(department => {
														return (<Select.Option key={department.Value} value={department.Value}>{department.Text}</Select.Option>)
													})
												}
											</Select>*/}
													{this.renderTreeNodes(departmentsList)}
												</TreeSelect>

											)}
										</Form.Item>
									}
								</div>
								<div className="position-form-item">
									<Form.Item label="编制人数">
										{this.props.form.getFieldDecorator('staff_size', {
											rules: [{ required: true, message: '请输入编制人数' }],
											initialValue: this.state.currentPosition.staff_size
										})(<InputNumber placeholder="编制人数" style={{ width: "400px", marginRight: "0px" }} />)}
									</Form.Item>
								</div>
								<div className="position-form-item">
									<Form.Item label="对应职务">
										{this.props.form.getFieldDecorator('business_id', {
											rules: [{ required: true, message: '请选择对应职务' }],
											initialValue: this.state.currentPosition.business_id
										})(
											<Select style={{ width: "400px" }} onChange={this.changeBusiness.bind(this)}>
												{this.props.departmentStructure.initPositionStatus &&
													this.props.departmentStructure.initPosition.Businesses.map((business, index) => {
														return (<Select.Option key={business.business_id} value={business.business_id}>
															{business.business_name}
														</Select.Option>)
													})}
											</Select>)}
									</Form.Item>
								</div>
								<div className="position-form-item">
									<Form.Item label="对应职级">
										{this.props.form.getFieldDecorator('business_level_value', {
											rules: [{ required: true, message: '请选择对应职级' }],
											initialValue: this.state.currentPosition.business_level_value
										})(
											<Select style={{ width: "400px" }}>
												{this.props.departmentStructure.initPositionStatus && this.state.currentBusinessIndex > -1 &&
													this.props.departmentStructure.initPosition.Businesses[this.state.currentBusinessIndex]
														.business_levels.map(level => {
															return (
																<Select.Option key={level} value={level}>{level}</Select.Option>
															)
														})}
											</Select>)}
									</Form.Item>
								</div>
								<div className="position-form-item" style={{ paddingLeft: "11px" }}>
									<Form.Item label="任职资格">
										{this.props.form.getFieldDecorator('qualifications', {
											rules: [],
											initialValue: this.state.currentPosition.qualifications
										})(
											<Input.TextArea style={{ width: "400px" }} rows="5">
											</Input.TextArea>)}
									</Form.Item>
								</div>
								<div className="position-form-item" style={{ paddingLeft: "11px" }}>
									<Form.Item label="责任描述">
										{this.props.form.getFieldDecorator('responsibility_description', {
											rules: [],
											initialValue: this.state.currentPosition.responsibility_description
										})(
											<Input.TextArea style={{ width: "400px" }} rows="5">
											</Input.TextArea>)}
									</Form.Item>
								</div>
							</Form>
						</div>
					}
				</Modal>
			</div>
		)
	}
}

DepartmentPosition = Form.create()(DepartmentPosition);

const mapStateToProps = state => {
	return {
		departmentStructure: state.departmentStructure
	}
};
const mapDispatchToProps = {
	fetchDepartmentPositionList,
	initPosition,
	addPosition,
	multiDeletePosition,
	updatePosition,
	initMovePosition,
	movePosition,
	fetchDepartmentsList
};


DepartmentPosition = LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(DepartmentPosition));

export default DepartmentPosition;


// WEBPACK FOOTER //
// ./src/routes/DepartmentStructure/DepartmentPosition.js